import styled, { css } from "styled-components";
import { LinkText } from "../Text";
export const Link = styled(LinkText) `
  ${(p) => p.theme.css.clickable};
  color: ${(p) => p.theme.colors.navy};
  :hover {
    text-decoration: underline;
  }
  ${({ isDisabled, theme }) => isDisabled &&
    css `
      color: ${theme.colors.black40};
      pointer-events: none;
    `}
`;
//# sourceMappingURL=index.js.map